import i18next from 'i18next';
import moment from 'moment';
import languageDetector from 'i18next-browser-languagedetector';
import aspect from '../common/aspect';

if (!i18next.isInitialized) {
  i18next.init();
  i18next.on('languageChanged', lng => {
    moment.locale(lng); // TODO how to share?  moment share lib?
  });
}

export function addNls(i18nInstance, nls) {
  Object.entries(nls).forEach(([language, rs]) => {
    Object.entries(rs).forEach(([namespace, r]) => {
      i18nInstance.addResourceBundle(language, namespace, r, true, true);
    });
  });
}

function initFn() {
  this.i18n = i18next.createInstance();
  this.i18n.use(languageDetector);
  this.i18n.init(
    {
      defaultNS: 'common',
      debug: false,
      resources: {},
    },
    err => {
      if (err) {
        console.log('something went wrong loading', err);
      }
    },
  );
  this.i18n.on('initialized', () => {
    this.requestUpdate();
  });
  this.i18n.on('languageChanged', () => {
    this.requestUpdate();
  });
  this.i18n.store.on('added', () => this.requestUpdate());
  this.i18n.store.on('removed', () => this.requestUpdate());
}

export default function i18n(nls) {
  return function decorator(target) {
    aspect(target.prototype, 'initialize', origin => {
      return function () {
        origin.apply(this);
        this.i18n || initFn.call(this, nls);
        addNls(this.i18n, nls);
      };
    });
  };
}

/*
 *
 * @i18n(nls)
 * class demo{
 * }
 *
 * @i18n(nls)
 * class B extends demo{}
 *
 * c = new B();
 * c.nls = {}
 *
 *
 * */
